module.exports = __webpack_public_path__ + "static/media/Inter-ExtraLight-BETA.9c975ca0.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-ExtraLight-BETA.woff2
// module id = 688
// module chunks = 21